import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SingleAddress } from '../company-customer-address/addressFunctions';

@Component({
  selector: 'single-address',
  templateUrl: './single-address.component.html',
  styleUrls: ['./single-address.component.css']
})
export class SingleAddressComponent implements OnInit {
  @Input() address : SingleAddress;
  @Output() addressChange = new EventEmitter();

  @Input() options = new SingleAddressOptions();

  constructor() { }

  ngOnInit(): void {
  }

}



export class SingleAddressOptions {
  useIcons: boolean = true;
}